export default __webpack_public_path__ + "static/media/winFriends.2669464d.jpg";